var app = angular.module('leonardo');

var IntercomController = function ($scope, $filter, $intercom, AuthService, AuthDataService) {

  $scope.loadIntercom = function(){
    if(AuthService.hasToken()){
      let user = {
        email: AuthDataService.authData.user.email,
        name: $filter('username')(AuthDataService.authData.user),
        user_id: AuthDataService.authData.user.id,
        created_at: Math.floor(new Date().getTime() / 1000)
      }
      $intercom.boot(user);
    }
  }
  $scope.loadIntercom();

  $scope.$on('auth-data:updated', function () {
    $scope.loadIntercom();
  });

  $scope.$on('user:logout', function (e) {
    $intercom.shutdown();
  });
};
app.controller('IntercomController', ['$scope', '$filter', '$intercom', 'AuthService', 'AuthDataService', IntercomController]);
